module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"pageTitle":"Produkte","allProducts":"Alle Produkte"},"en":{"pageTitle":"Products","allProducts":"All Products"}}')
  delete Component.options._Ctor
}
